import fetch from 'isomorphic-fetch';
import Cookies from 'js-cookie';
import { config } from '@app/config';
import { LOAD_CATEGORIES } from '@app/modules/categoriesReducer';
import { logError } from '@app/middleware/logger';
import seoDefaultData from './default/data';

const VALIDATE_URL = 'paramsFilters/VALIDATE_URL';
const VALIDATE_URL_SUCCESS = 'paramsFilters/VALIDATE_URL_SUCCESS';
const VALIDATE_URL_FAIL = 'paramsFilters/VALIDATE_URL_FAIL';

export function getCategories() {
  const url = `${config.gatewayUrl}/v7/public/chapy-pro/newcats`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        const { categories, code } = result;
        if (code === 'SUCCESS') {
          return resolve(categories);
        }
        return resolve([]);
      })
      .catch((err) => {
        logError(`GET ${url}`, null, err);
        return resolve([]);
      });
  });
}

export function getBanners() {
  const url = `${config.gatewayUrl}/v1/public/buyer-collection/banners?mode=JOB`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        const { banners, status } = result;
        if (status === 'success') {
          return resolve(banners);
        }
        return resolve([]);
      })
      .catch((err) => {
        logError(`GET ${url}`, null, err);
        return resolve([]);
      });
  });
}

export function getSeo(region) {
  const url = `${config.gatewayUrl}/v1/public/seo-api/tag?siteId=4&uri=homepage-job`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((data) => {
        if (data.errors) {
          return resolve(seoDefaultData);
        }
        const { wardValue = 0, regionName, subRegionValue } = region;
        const { seoData, keywords } = data;
        const subRegionName = subRegionValue === 0 ? '' : region.subRegionName;
        const wardName = wardValue === 0 ? '' : region.wardName;
        const locationName = refineLocation({ wardName, subRegionName, regionName });

        seoData.title = replaceLocationSEO(seoData.title, locationName);

        seoData.h1 = replaceLocationSEO(seoData.h1, locationName);

        // replace location for SEO title cat description...
        seoData.catDescription = replaceLocationSEO(seoData.catDescription, locationName);

        seoData.meta.forEach((item, index) => {
          seoData.meta[index].content = replaceLocationSEO(
            seoData.meta[index].content,
            locationName
          );
        });

        return resolve({
          data: {
            seo: {
              seoData,
              keywords,
            },
          },
        });
      })
      .catch((err) => {
        logError(`GET ${url}`, null, err);
        return resolve(seoDefaultData);
      });
  });
}

function replaceLocationSEO(str, location = '') {
  if (!str) return str;

  let newLocation = location;
  if (['Tp Hồ Chí Minh', 'Tp. Hồ Chí Minh'].indexOf(location) !== -1) {
    newLocation = 'Tp.HCM';
  }
  let newStr = str.replace(/(\[SEO_LOCATION])/g, newLocation);

  // Replace Date data to current Date time
  if (newStr.match(/(\[DD]|\[YY]|\[MM])/g)) {
    const currentDate = new Date();
    newStr = newStr.replace(/(\[DD\])/g, ('0' + currentDate.getDate()).substr(-2));
    newStr = newStr.replace(/(\[MM\])/g, ('0' + (currentDate.getMonth() + 1)).substr(-2));
    newStr = newStr.replace(/(\[YY\])/g, currentDate.getFullYear());
  }

  return newStr;
}

function refineLocation(props) {
  if (['Tp Hồ Chí Minh', 'Tp. Hồ Chí Minh', 'Đà Nẵng', 'Hà Nội'].indexOf(props.regionName) !== -1) {
    if (props.subRegionName) {
      return props.wardName ? `${props.wardName}, ${props.subRegionName}` : props.subRegionName;
    }
  }

  let location = '';
  const args = ['wardName', 'subRegionName', 'regionName'];
  args.forEach((arg) => {
    if (props[arg]) {
      location = `${location} ${props[arg]}`;
    }
  });

  return location;
}

export function getTotalEntryPoint() {
  const url = `${config.gatewayUrl}/v1/public/ad-listing/count?cg=13020`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        result.isDone = true;
        return resolve(result);
      })
      .catch((err) => {
        logError(`GET ${url}`, null, err);
        return resolve([]);
      });
  });
}

export function getTotalNew() {
  const url = `${config.gatewayUrl}/v1/public/ad-listing/count?cg=13010&limit=10&st=s,k&key_param_included=true`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        result.isDone = true;
        return resolve(result);
      })
      .catch((err) => {
        logError(`GET ${url}`, null, err);
        return resolve([]);
      });
  });
}

export function getAdsRecommend({ authenticated = false, account_id: accountId }) {
  let fingerPrint = Cookies.get('ctfp');
  if (authenticated) {
    fingerPrint = accountId;
  }
  const url = `${config.gatewayUrl}/v1/public/personalized/ad-listing?cg=13000&fingerprint=${fingerPrint}&limit=20&key_param_included=true `;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        result.isDone = true;
        return resolve(result);
      })
      .catch((err) => {
        logError(`GET ${url}`, null, err);
        return resolve([]);
      });
  });
}

export function getAdsNew(region) {
  let regionString = ``;
  if (region.regionValue > 0) {
    regionString += `${'&region_v2=' + region.regionValue}`;
  }
  if (region.subRegionValue > 0) {
    regionString += `${'&area_v2=' + region.subRegionValue}`;
  }
  if (region.wardValue > 0) {
    regionString += `${'&ward=' + region.wardValue}`;
  }
  const url = `${config.gatewayUrl}/v1/public/ad-listing?cg=13010&limit=10${regionString}&key_param_included=true`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        result.isDone = true;
        return resolve(result);
      })
      .catch((err) => {
        logError(`GET ${url}`, null, err);
        return resolve([]);
      });
  });
}

export function getTotalProject() {
  const url = `${config.gatewayUrl}/v1/public/xproperty/projects/_search?limit=8&status=active`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        result.isDone = true;
        return resolve(result);
      })
      .catch(() => {
        return resolve([]);
      });
  });
}

export function getTotalProjectAgent() {
  const url = `${config.gatewayUrl}/v1/public/shops/search?limit=8&category_id=2000`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        result.isDone = true;
        return resolve(result);
      })
      .catch(() => {
        return resolve([]);
      });
  });
}

export function getCatBlog() {
  const url = `${config.jobURL}/kinh-nghiem/wp-json/wp/v2/categories?parent=0`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        const res = {
          data: [],
          isDone: true,
        };
        res.isDone = true;
        res.data = result;
        return resolve(res);
      })
      .catch((err) => {
        logError(`GET ${url}`, null, err);
        return resolve([]);
      });
  });
}

export function getTotalBlog(cat = '') {
  if (cat !== '') {
    cat = '&categories=' + cat;
  }
  const url = `${config.jobURL}/kinh-nghiem/wp-json/wp/v2/posts?per_page=30&order=desc&orderby=date${cat}`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        const res = {
          data: [],
          isDone: true,
        };
        let temp = [];
        for (let i = 0; i < result.length; i++) {
          if (result[i].categories.includes(1214)) {
            const desc =
              result[i].excerpt.rendered !== ''
                ? result[i].excerpt.rendered.replace(/<\/?[^>]+(>|$)/g, '')
                : '';

            const ad = {
              id: result[i].id || 1,
              image: result[i].images.medium || '',
              title: result[i].title.rendered || '',
              intro: (result[i].yoast_head_json && result[i].yoast_head_json.description) || desc,
              url: result[i].link || '',
              categories: result[i].categories || [],
              date: result[i].date,
            };
            temp.push(ad);
          }
        }
        if (temp && temp.length > 8) {
          temp = temp.splice(0, 8);
        }
        res.data = [...temp];
        return resolve(res);
      })
      .catch((err) => {
        logError(`GET ${url}`, null, err);
        return resolve([]);
      });
  });
}

export function getPopularKeyword({ authenticated = false, account_id: accountId }, limit = 5) {
  let fingerPrint = Cookies.get('ctfp');
  if (authenticated) {
    fingerPrint = accountId;
  }
  const url = `${config.gatewayUrl}/v1/public/recommender/collection_for_you?fingerprint=${fingerPrint}&limit=${limit}&cg=2000`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        result.isDone = true;
        return resolve(result);
      })
      .catch(() => {
        return resolve([]);
      });
  });
}

export function getServiceShortcut() {
  const url = `${config.gatewayUrl}/v1/public/buyer-collection/web/quick-shortcut?site=VEH`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        const res = {
          data: [],
          isDone: true,
        };
        res.isDone = true;
        res.data = result.quick_shortcut;
        return resolve(res);
      })
      .catch(() => {
        return resolve([]);
      });
  });
}

export function validateUrlApi(dispatch) {
  dispatch(validateUrl());

  const url = `${config.gatewayUrl}/v1/public/deeplink-resolver?url=${config.vehicleURL}&siteId=2`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        dispatch(validateUrlSuccess(result));
        return resolve(result);
      })
      .catch((err) => {
        logError(`GET ${url}`, null, err);
        return resolve([]);
      });
  });
}

export function getEntitlementAds(region) {
  const url = `${config.gatewayUrl}/v1/public/ad-listing?cg=13010&limit=10&key_param_included=true&protection_entitlement=true&region_v2=${region}`;
  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        result.isDone = true;
        return resolve(result);
      })
      .catch((err) => {
        logError(`GET ${url}`, null, err);
        return resolve([]);
      });
  });
}

export function validateUrl() {
  return {
    type: VALIDATE_URL,
    payload: {},
  };
}
export function validateUrlSuccess(data) {
  return {
    type: VALIDATE_URL_SUCCESS,
    payload: { ...data },
    result: { ...data },
  };
}
export function validateUrlFail(error) {
  return {
    type: VALIDATE_URL_FAIL,
    payload: { error },
  };
}

export function getQuickShortCut() {
  const url = `${config.gatewayUrl}/v1/public/buyer-collection/all/quick-shortcut/groups/JOB`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        const res = {
          data: [],
          isDone: true,
        };
        res.isDone = true;
        res.data = result;
        return resolve(res);
      })
      .catch((err) => {
        logError(`GET ${url}`, null, err);
        return resolve([]);
      });
  });
}

export function getJobCollection(siteId = 'JOB_HOMEPAGE-VLT_COLLECTION') {
  const url = `${config.gatewayUrl}/v1/public/buyer-collection/app/quick-shortcut?site=${siteId}`;

  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        const res = {
          data: [],
          isDone: true,
        };
        res.isDone = true;
        res.data = result;
        return resolve(res);
      })
      .catch((err) => {
        logError(`GET ${url}`, null, err);
        return resolve([]);
      });
  });
}

export function getUrgentJobAds() {
  const url = `${config.gatewayUrl}/v1/public/ad-listing?cg=13000&job_urgent_recruit_enabled=1&key_param_included=true&limit=10`;
  return new Promise((resolve) => {
    fetch(url)
      .then((data) => data.json())
      .then((result) => {
        result.isDone = true;
        return resolve(result);
      })
      .catch((err) => {
        logError(`GET ${url}`, null, err);
        return resolve({ isDone: true });
      });
  });
}

export const loadCategoriesData = (categories) => {
  return {
    type: LOAD_CATEGORIES,
    payload: categories,
  };
};
